interface Props {
    coverLetter: string;
    styles: any;
}

export const CoverLetterTab: React.FC<Props> = (props) => {
    const styles = props.styles;  

    return (
        <div style={styles.mainWrapper}>
            <div style={styles.rowWrapper}>
                <div style={styles.title}>Cover Letter</div>
            </div>
            <div style={styles.coverLetter}>
                <div 
                    style={styles.coverLetter.text}
                    dangerouslySetInnerHTML={{ __html: props.coverLetter }}
                />
            </div>
        </div>
    )
}